<template>
  <svg id="discount-2" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <g id="Group_1401" data-name="Group 1401">
      <path
        id="Path_4828"
        data-name="Path 4828"
        d="M15.8,7.528,14,5.724V2.667A.667.667,0,0,0,13.333,2H10.276L8.471.2a.666.666,0,0,0-.943,0L5.724,2H2.667A.667.667,0,0,0,2,2.667V5.724L.2,7.528a.666.666,0,0,0,0,.943l1.8,1.8v3.057A.667.667,0,0,0,2.667,14H5.724l1.8,1.8a.666.666,0,0,0,.943,0l1.8-1.8h3.057A.667.667,0,0,0,14,13.333V10.276l1.8-1.8A.666.666,0,0,0,15.8,7.528ZM5.666,4.666a1,1,0,1,1-1,1A1,1,0,0,1,5.666,4.666Zm4.667,6.667a1,1,0,1,1,1-1A1,1,0,0,1,10.333,11.333Zm-5,.276-.943-.943L10.666,4.39l.943.943Z"
        transform="translate(0 0)"
        fill="#e02020"
      />
    </g>
  </svg>
</template>
